import { Flex } from 'antd'
import styled from 'styled-components'
import media from 'styled-media-query'

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 9998;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const CookieBannerContainer = styled(Flex)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  padding: 24px;
  z-index: 9999;
  border-top: 3px solid var(--blue-darker);
  animation: slideUp 0.3s ease-in-out;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
  
  ${media.lessThan('medium')`
    padding: 16px;
  `}

  .banner-content {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;

    ${media.lessThan('medium')`
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    `}
  }

  .banner-text {
    flex: 1;

    h3 {
      margin: 0 0 8px 0;
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;

      ${media.lessThan('medium')`
        font-size: 16px;
      `}
    }

    p {
      margin: 0;
      font-size: 14px;
      color: #666;
      line-height: 1.5;

      ${media.lessThan('medium')`
        font-size: 13px;
      `}
    }
  }

  .banner-actions {
    display: flex;
    gap: 12px;
    flex-shrink: 0;

    ${media.lessThan('medium')`
      width: 100%;
      flex-direction: column;
      gap: 8px;
    `}
  }
`

export const AcceptButton = styled.button`
  background: var(--blue-darker);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 127, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  ${media.lessThan('medium')`
    width: 100%;
    padding: 14px 24px;
  `}
`

export const DeclineButton = styled.button`
  background: transparent;
  color: #666;
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    border-color: #999;
    color: #333;
    background: #f5f5f5;
  }

  &:active {
    transform: translateY(0);
  }

  ${media.lessThan('medium')`
    width: 100%;
    padding: 14px 24px;
  `}
`
